import { Messages } from '@liquid-state/iwa-core';
import Key from './key';
var KeyValueStore = /** @class */ (function () {
    function KeyValueStore(communicator, defaultPermissions) {
        this.communicator = communicator;
        this.defaultPermissions = defaultPermissions;
    }
    KeyValueStore.prototype.get = function (key) {
        return this.communicator.send(Messages.kv.get([key]))
            .then(function (response) {
            var value = response[key].found ? response[key].value : null;
            return new Key(key, value);
        });
    };
    KeyValueStore.prototype.set = function (key) {
        var keyData = key.prepareForSave();
        if (keyData.useDefaultPermissions && this.defaultPermissions) {
            keyData.data.permissions = this.defaultPermissions;
        }
        this.communicator.send(Messages.kv.set([keyData.data]));
    };
    KeyValueStore.prototype.create = function (key, value) {
        return new Key(key, value);
    };
    ;
    return KeyValueStore;
}());
export default KeyValueStore;
//# sourceMappingURL=store.js.map